export default "__VITE_ASSET__BTStE43h__"